import type { MessageKey } from '../i18n';
import { publicPath } from '../publicPath';

/** Billboard source size — carousel height follows this ratio at full width. */
export const HOME_PROMO_AD_FRAME_WIDTH = 300;
export const HOME_PROMO_AD_FRAME_HEIGHT = 168;

/** Bump when replacing files under public/home-ads/ so browsers pick up new art. */
export const HOME_PROMO_AD_ASSET_VERSION = 15;

export type HomePromoAd = {
  id: string;
  imageSrc: string;
  labelKey: MessageKey;
  /** When true, crop to the billboard frame; reference slide shows in full. */
  cropToFrame?: boolean;
  objectPosition?: string;
};

function promoAdSrc(path: string): string {
  return `${publicPath(path)}?v=${HOME_PROMO_AD_ASSET_VERSION}`;
}

/** Paths under `/home-ads/` — not `/images/` (dev proxy forwards `/images` to the API). */
export const HOME_PROMO_ADS: HomePromoAd[] = [
  {
    id: 'register-discount',
    imageSrc: promoAdSrc('/home-ads/promo-register-discount.png'),
    labelKey: 'home.promoAd.registerDiscount',
    cropToFrame: true,
    objectPosition: 'center center',
  },
  {
    id: 'refer-friend',
    imageSrc: promoAdSrc('/home-ads/promo-refer-friend.png'),
    labelKey: 'home.promoAd.referFriend',
    cropToFrame: true,
    objectPosition: 'center center',
  },
  {
    id: 'app-locations',
    imageSrc: promoAdSrc('/home-ads/promo-app-locations.png'),
    labelKey: 'home.promoAd.appLocations',
    cropToFrame: true,
    objectPosition: 'center center',
  },
];

export const HOME_PROMO_AD_AUTOPLAY_MS = 3000;
